
export function smoothstep(edge0: number, edge1: number, x: number) {
    x = clamp((x - edge0) / (edge1 - edge0));
    return x * x * (3.0 - 2.0 * x);
}

export function clamp(x: number, min: number = 0.0, max: number = 1.0) {
    if (x < min) return min;
    if (x > max) return max;
    return x;
}